import React from 'react';
import { Button } from '@blink/components';
import { ReactComponent as Metamask } from '@blink/assets/src/icons/metamask.svg';
import { METAMASK_DOWNLOAD_URL } from '@blink/components/src/constants/global';

import { useModalStyles } from './MetamaskNotInstalledModal.style';
import { useHideModal } from '../ModalWrapperHooks';

export const MetamaskNotInstalledModal = () => {
    const classes = useModalStyles();

    const { handleCloseModal } = useHideModal();

    const openMetamaskInstall = () => {
        window.open(METAMASK_DOWNLOAD_URL, '_blank', 'noreferrer');
        handleCloseModal();
    };

    return (
        <>
            <div className={classes.wrapper}>
                <div className={classes.icon}>
                    <Metamask />
                </div>
                <div className={classes.title}>MetaMask is not installed</div>
                <div className={classes.description}>
                    The MetaMask extension is not installed <br /> in your browser
                </div>
                <div className={classes.btn}>
                    <Button name='Install' onClick={openMetamaskInstall} />
                </div>
            </div>
        </>
    );
};
